const pad = (string: string, length = 30) => {
  const padLength = Math.round((length + string.length) / 2);
  return string.padEnd(padLength, ' ').padStart(length, ' ');
};

const printMs = (ms: number) => {
  const result = String(Math.round(ms)).padStart(4, ' ') + 'ms';
  let emoji = '🔴';
  if (ms < 50) {
    emoji = '⚡️';
  } else if (ms < 100) {
    emoji = '🔵';
  } else if (ms < 200) {
    emoji = '🟢';
  } else if (ms < 300) {
    emoji = '🟡';
  } else if (ms < 400) {
    emoji = '🟠';
  }
  return `${emoji} ${result}`;
};

const trim = (string: string, length = 60) => {
  return string.length > length ? string.substr(0, length - 3) + '...' : string;
};

export const logUtils = {
  pad,
  printMs,
  trim,
  stringToEmojiHash,
};

async function hashWithWebCrypto(input: string): Promise<string> {
  // Convert the input string into an ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  // Compute the SHA-256 hash using Web Crypto API
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert the hash (ArrayBuffer) into a hexadecimal string
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

// Function to generate a hash and map it to emojis
async function stringToEmojiHash(
  input: string,
  length: number,
  emojieList = EMOJIE_VEGGIE_LIST
) {
  // Step 1: Create a SHA-256 hash of the input string
  const hash = await hashWithWebCrypto(input);

  let emojiSequence = '';
  for (let i = 0; i < length; i++) {
    // Convert two hex characters to a number to map to an emoji
    const hexPair = hash.slice(i * 2, i * 2 + 2); // Take two characters at a time
    const emojiIndex = parseInt(hexPair, 16) % emojieList.length; // Map hex to emoji index
    emojiSequence += emojieList[emojiIndex];
  }

  return emojiSequence;
}

const EMOJIE_VEGGIE_LIST = [
  '🍏',
  '🍎',
  '🍐',
  '🍊',
  '🍋',
  '🍌',
  '🍉',
  '🍇',
  '🍓',
  '🍈',
  '🍒',
  '🍑',
  '🥭',
  '🍍',
  '🥥',
  '🥝',
  '🍅',
  '🍆',
  '🥑',
  '🥦',
  '🥬',
  '🥒',
  '🌶️',
  '🌽',
  '🥕',
  '🧄',
  '🧅',
  '🥔',
  '🍠',
  '🥜',
  '🌰',
];
